import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: () => {
    return {
      slides: [],
      loading: false,
      working: false,
    };
  },
  getters: {
    slides(state) {
      return state.slides;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setData(state, payload) {
      state.slides = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchSlides({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchSlides();
        commit("setData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editSlide({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        var toSend = new FormData();
        for (const key in payload) {
          if (Object.hasOwnProperty.call(payload, key)) {
            const element = payload[key];
            toSend.append(key, element);
          }
        }
        toSend.append("_method", "PUT");
        if (typeof toSend.get("source") === "string") toSend.delete("source");
        const res = await ministryService.updateSlide({
          form: toSend,
          id: payload.id,
        });

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchSlides");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async addSlide({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        var toSend = new FormData();
        for (const key in payload) {
          if (Object.hasOwnProperty.call(payload, key)) {
            const element = payload[key];
            toSend.append(key, element);
          }
        }
        const res = await ministryService.addSlide(toSend);

        if (hasError(res.status)) {
          throw res.status;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchSlides");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteSlide({ commit, dispatch }, id) {
      commit("setWorking", true);
      try {
        const res = await ministryService.deleteSlide(id);

        if (hasError(res.status)) {
          throw res.status;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        await dispatch("fetchSlides");
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
